<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DAFTAR BED KOSONG
                </h1>
                <p class="font-sm text-center mt-2">
                    TANGGAL JAM {{ bedKosong.tglJam }}
                </p>
                <p class="font-sm font-bold text-center mt-2">
                    TOTAL BED KOSONG: {{ bedKosong.totalBedKosong }}
                </p>
            </div>
            <div class="w-full my-3">
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500"
                            >{{ timerCount }}</span
                        >
                    </p>
                </div>
                <div class="w-full grid grid-cols-2 gap-2">
                    <div v-for="bedKosong in bedKosongData" class="w-full bg-white rounded-md shadow p-3 mb-5">
                        <div class="w-3/4 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3">
                            <table class="w-full whitespace-nowrap">
                                <tr class="text-left font-bold bg-amber-100">
                                    <td class="py-2 px-3 text-center text-sm">RUANG</td>
                                    <td class="py-2 px-3 text-center text-sm">{{bedKosong.ruang}}</td>
                                </tr>
                                <tr class="hover:bg-gray-100">
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">BED KOSONG</td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{bedKosong.kosong}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                            <table class="w-full whitespace-nowrap">
                                <thead>
                                    <tr class="text-left font-bold bg-amber-100">
                                        <th class="py-2 px-3 text-center text-sm">
                                            No
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Nama BED
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="bed in bedKosong.data"
                                        class="hover:bg-gray-100"
                                    >
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ bed.no }}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{bed.nama_bed}}
                                        </td>
                                    </tr>
                                    <tr class="bg-white hover:bg-gray-200 focus-within:bg-gray-200" v-if="bedKosong.data.length === 0">
                                        <td class="border-r border-t text-sm select-none cursor-pointer" colspan="9">
                                            Belum ada data bed kosong
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
    },
    data() {
        return {
            tglJamData: this.tglJam,
            bedKosongData: this.bedKosong.data,
            timerCount: 10,
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getBedKosong();
                }
            },
            immediate: true,
        },
    },
    props: {
        bedKosong: Object,
    },
    methods: {
        getBedKosong() {
            this.$inertia.get(
                "/admin/bed_kosong/ajax",
                {
                    
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 10;
                        this.bedKosongData = page.props.additional.bedKosong.data;
                    },
                }
            );
        },
    },
    layout: LayoutAdmin,
};
</script>
